import { environment } from '../../../environments/environment';

export const APP_CONSTANTS = {
  API: {
    BASE_URL: environment.apiUrl,
    ENDPOINTS: {
      DASHBOARD_STATS: 'dashboardStats',
      CALENDAR_EVENTS: 'calendarEvents',
      REQUESTS: 'requests',
      INVOICES: 'invoices',
      ANNOUNCEMENTS: 'announcements',
      CLASSIFIED_ADS: 'classifiedAds',
    },
  },
  UI: {
    LOADING_DELAY: 1000,
    PAGINATION: {
      DEFAULT_PAGE_SIZE: 10,
      PAGE_SIZE_OPTIONS: [5, 10, 25, 50],
    },
  },
  ROUTES: {
    DASHBOARD: '/dashboard',
    REQUESTS: '/requests',
    SERVICE_REQUEST: '/service-request',
  },
  STATUS: {
    REQUEST: {
      PENDING: 'pending',
      IN_PROGRESS: 'in_progress',
      COMPLETED: 'completed',
      CANCELLED: 'cancelled',
    },
    INVOICE: {
      PAID: 'paid',
      UNPAID: 'unpaid',
      OVERDUE: 'overdue',
    },
  },
} as const;

export type AppConstants = typeof APP_CONSTANTS;
